<template>
  <component :is="'style'">
    #main-scrolling { scrollbar-gutter: unset; }
  </component>
</template>

<script>
/**
 * A gutter space is reserved for the page scroll. This component removes that gutter space
 */
export default {
  name: 'RemoveBodyScrollGutter',
  props: [],
  components: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
